import React from 'react';
import ReactDOM from 'react-dom/client';
import '../node_modules/@destination/components/dist/index.css';
import './index.css';
import { RouterProvider } from 'react-router';
import { router } from '@routes/router';
import { SWRConfig } from 'swr';

import './i18n';
import { AlertProvider, Sidebar } from '@destination/components';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest, msalInstance } from './authConfig';
import { AppInsightsProvider } from '@/AppInsightsProvider';
import { ErrorBoundary } from 'react-error-boundary';
import { GeneralFallback } from '@components/GeneralFallback';

//i18next's t method can now return a null value which needs to be prevented.
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const swrConfig = { shouldRetryOnError: false };

const isLocal = process.env.NODE_ENV === 'development';

export const config = await fetch('/config.json').then(response =>
  response.json()
);

const appInsightsKey = !isLocal
  ? config['ai-instrumentation-key']
  : 'development';

// eslint-disable-next-line vitest/require-hook
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ErrorBoundary FallbackComponent={GeneralFallback}>
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          authenticationRequest={loginRequest}
        >
          <SWRConfig value={swrConfig}>
            <AppInsightsProvider connectionString={appInsightsKey}>
              <Sidebar.Provider>
                <AlertProvider>
                  <RouterProvider router={router} />
                </AlertProvider>
              </Sidebar.Provider>
            </AppInsightsProvider>
          </SWRConfig>
        </MsalAuthenticationTemplate>
      </ErrorBoundary>
    </MsalProvider>
  </React.StrictMode>
);
